package ru.it_mozaika.sender.js.application.routes

import oldframes.subscribers.lists.oldSubscriptionListFrame
import js.core.jso
import react.Props
import react.createElement
import react.router.RouteObject
import ru.it_mozaika.sender.js.application.frames.subscribers.lists.subscriptionListsFrame

val subscriptionsRoutes = jso<RouteObject> {
    path = "subscriptions"
    children = arrayOf(
//        jso {
//            path = ":id"
//            index = true
//            element = createElement<Props> {
//                oldSubscriptionListFrame {}
//            }
//        },
        jso {
            path = ""
            index = true
            element = createElement<Props> {
                subscriptionListsFrame{}
//                oldSubscriptionListsFrame {}
            }
        }
    )

}
